import { Drawer, Text } from '@mantine/core';
import Library from '@/components/library';

interface LibraryDrawerProps {
	isOpen: boolean;
	onClose: () => void;
}

const LibraryDrawer = ({ isOpen, onClose }: LibraryDrawerProps) => {
	return (
		<Drawer
			onClose={onClose}
			opened={isOpen}
			position="right"
			size="lg"
			title={
				<Text
					className="notranslate"
					fw={600}
					fz={20}
					translate="no"
				>
					Library Items
				</Text>
			}
		>
			<div
				className="notranslate"
				translate="no"
			>
				<Library onClose={onClose} />
			</div>
		</Drawer>
	);
};

export default LibraryDrawer;
